"use client";

import React, { forwardRef, useRef } from "react";
import { cn } from "../../../lib/utils";
import { AnimatedTools } from "./animated-tools";

const Circle = forwardRef<
  HTMLDivElement,
  { className?: string; children?: React.ReactNode }
>(({ className, children }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(
        "z-10 flex h-16 w-16 flex-shrink-0 items-center justify-center rounded-full bg-white dark:bg-gray-300 shadow-md",
        className,
      )}
    >
      {children}
    </div>
  );
});

Circle.displayName = "Circle";

export function AnimatedToolsDemo() {
  const containerRef = useRef<HTMLDivElement>(null);
  const div1Ref = useRef<HTMLDivElement>(null);
  const div2Ref = useRef<HTMLDivElement>(null);
  const div3Ref = useRef<HTMLDivElement>(null);
  const div4Ref = useRef<HTMLDivElement>(null);
  const div5Ref = useRef<HTMLDivElement>(null);
  const div6Ref = useRef<HTMLDivElement>(null);
  const div7Ref = useRef<HTMLDivElement>(null);

  return (
    <div
      className="relative flex h-[500px] w-full items-center justify-center overflow-hidden rounded-lg border bg-background p-10"
      ref={containerRef}
    >
      <div className="absolute inset-0 z-0 bg-[radial-gradient(circle,rgba(0,0,0,0.1)_1px,transparent_1px)] dark:bg-[radial-gradient(circle,rgba(255,255,255,0.1)_1px,transparent_1px)] bg-[size:20px_20px]" />
      <div className="flex size-full flex-col max-w-lg max-h-[200px] items-stretch justify-between gap-10">
        <div className="flex flex-row items-center justify-between">
          <Circle ref={div1Ref}>
            <img src="/logos/gmail.svg" alt="Gmail" className="h-10 w-10 object-contain" />
          </Circle>
          <Circle ref={div5Ref}>
            <img src="/logos/zendesk.svg" alt="Zendesk" className="h-10 w-10 object-contain" />
          </Circle>
        </div>
        <div className="flex flex-row items-center justify-between">
          <Circle ref={div2Ref}>
            <img src="/logos/slack.svg" alt="Slack" className="h-10 w-10 object-contain" />
          </Circle>
          <Circle ref={div4Ref}>
            <img src="/44.svg" alt="44" className="h-12 w-12 object-contain" />
          </Circle>
          <Circle ref={div6Ref}>
            <img src="/logos/microsoft.svg" alt="Microsoft" className="h-10 w-10 object-contain" />
          </Circle>
        </div>
        <div className="flex flex-row items-center justify-between">
          <Circle ref={div3Ref}>
            <img src="/logos/telegram.svg" alt="Telegram" className="h-10 w-10 object-contain" />
          </Circle>
          <Circle ref={div7Ref}>
            <img src="/logos/stripe.svg" alt="Stripe" className="h-12 w-12 object-contain" />
          </Circle>
        </div>
      </div>

      <AnimatedTools containerRef={containerRef} fromRef={div1Ref} toRef={div4Ref} curvature={-75} endYOffset={-10} />
      <AnimatedTools containerRef={containerRef} fromRef={div2Ref} toRef={div4Ref} />
      <AnimatedTools containerRef={containerRef} fromRef={div3Ref} toRef={div4Ref} curvature={75} endYOffset={10} />
      <AnimatedTools containerRef={containerRef} fromRef={div5Ref} toRef={div4Ref} curvature={-75} endYOffset={-10} reverse />
      <AnimatedTools containerRef={containerRef} fromRef={div6Ref} toRef={div4Ref} reverse />
      <AnimatedTools containerRef={containerRef} fromRef={div7Ref} toRef={div4Ref} curvature={75} endYOffset={10} reverse />
    </div>
  );
}

